import { render } from "./Carousel-edit.vue?vue&type=template&id=ef8a4664&scoped=true"
import script from "./Carousel-edit.vue?vue&type=script&lang=js"
export * from "./Carousel-edit.vue?vue&type=script&lang=js"

import "./Carousel-edit.vue?vue&type=style&index=0&id=ef8a4664&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef8a4664"]])

export default __exports__